<template>
  <div class="spin-numbers">
    <div v-for="(n, index) in numbers" :key="index" class="number">
      <img :src="img">
    </div>
  </div>
</template>
<script>
export default {
  name: 'DisplayEmptyBall',
  props: {
    lang: {
      type: String,
      required: true
    },
    length: {
      type: [Number, String],
      required: true
    }
  },
  computed: {
    numbers() {
      return new Array(+this.length)
    },
    img() {
      return require(`@/assets/theme/${this.lang}/n.png`)
    }
  }
}
</script>
